import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../images/renuit_logo.png';

const PRIVACY_TEXT = `Renuit Logistics ("we," "us," or "our") collects personal information you voluntarily submit through our contact form — including your name, email address, phone number, and message. We use this information solely to respond to your inquiry and to deliver requested services. We do not sell, rent, or disclose your personal data to third parties for marketing purposes. Data is transmitted securely and retained only as long as necessary to fulfil your request. You may request deletion of your data at any time by contacting us at support@renuit.pro. By submitting the contact form you consent to the collection and use of your information as described above. This site uses Google Analytics 4 to analyze usage in aggregate. No personally identifiable information is collected by analytics. You may opt out via your browser settings.`;

export const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
<footer id="cs-footer-272">
    <div className="cs-container">
        <div className="cs-logo-group">
            <Link aria-label="go back to home" className="cs-logo" to="/">
                <img className="cs-logo-img light" loading="lazy" decoding="async" src={logo} alt="Renuit Logistics" width="240" height="32"/>
            </Link>
            <p className="cs-text">
            We move freight across the Southeast U.S. — with the tracking, the calls, and the accountability most brokers skip.
            </p>
        </div>
        <ul className="cs-nav">
            <li className="cs-nav-li">
                <span className="cs-header">Sitemap</span>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/">Home</Link>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/about">About</Link>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/services">Services</Link>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/coverage">Coverage</Link>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/quote">Get a Quote</Link>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/careers">Careers</Link>
            </li>
            <li className="cs-nav-li">
                <Link className="cs-nav-link" to="/contact">Contact</Link>
            </li>
        </ul>
        <ul className="cs-contact">
            <li className="cs-nav-li">
                <span className="cs-header">Contact</span>
            </li>
            <li className="cs-contact-li">
                <address className="cs-contact-link cs-address" style={{fontStyle:'normal'}}>
                360 Central Avenue, Office #310<br/> St. Petersburg, FL, 33701
                </address>
            </li>
            <li className="cs-contact-li">
                <a className="cs-contact-link" href="tel: 786-628-3731">(786) 628-3731</a>
            </li>
            <li className="cs-contact-li">
                <a className="cs-contact-link" href="mailto:support@renuit.pro">support@renuit.pro</a>
            </li>
            <li className="cs-contact-li">
                <span className="cs-contact-link cs-license">Licensed · Bonded · Insured</span>
            </li>
        </ul>
    </div>
    <div className="cs-footer-bottom">
      <span>© 2026 Renuit Logistics. All rights reserved.</span>
      <button className="cs-privacy-btn" onClick={() => setShowPrivacy(true)}>
        Privacy Policy
      </button>
    </div>
    {showPrivacy && (
      <div
        className="cs-privacy-overlay"
        role="dialog"
        aria-modal="true"
        aria-label="Privacy Policy"
        onClick={() => setShowPrivacy(false)}
      >
        <div className="cs-privacy-modal" onClick={e => e.stopPropagation()}>
          <div className="cs-privacy-modal__header">
            <h2>Privacy Policy</h2>
            <button
              className="cs-privacy-modal__close"
              onClick={() => setShowPrivacy(false)}
              aria-label="Close privacy policy"
            >
              ✕
            </button>
          </div>
          <p className="cs-privacy-modal__body">{PRIVACY_TEXT}</p>
        </div>
      </div>
    )}
</footer>
                                
  );
}
